import { Box, Typography } from "@mui/material";
import { PrepForBlockResult } from "./PrepForBlockResult";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const BlockResult = ({ statDat, saveFullApartSquare, CustomBox }) => {
  const BlockResult = statDat.map((apart, index) => {
    const fullName = apart.name;
    const textPaycheck = apart.name.split(", ").pop();
    return (
      <div key={index}>
        <Typography textAlign="center" variant="h2" fontWeight="500" mt={4}>
          <Box display="inline-flex" alignItems="center">
            <InfoOutlinedIcon color="primary" sx={{ mr: 1 }} />
            {/* {console.log("apart", apart)} */}
            {/* Данные {apart.name.split("Доход").pop()} */}
            {apart.name.includes("Метраж") === true ? apart.name : "Данные" + apart.name.split("Доход").pop()}
          </Box>
        </Typography>

        <PrepForBlockResult
          apart={apart}
          textPaycheck={textPaycheck}
          CustomBox={CustomBox}
          fullName={fullName}
          saveFullApartSquare={saveFullApartSquare}
        />
      </div>
    );
  });
  return <>{BlockResult}</>;
};
